import { useSelector } from 'react-redux';
import adminSelectors from 'store/admin/selectors';

const useDumpsState = () => {
  const dumps = useSelector(adminSelectors.dumps.getExportFolders);
  const isDumpsLoading = useSelector(adminSelectors.dumps.isExportFoldersLoading);
  return {
    dumps,
    isDumpsLoading,
    isDumpsLoaded: dumps && !!dumps?.length,
  };
};

export { useDumpsState };
